import React, { Component } from 'react';
import BasePage from './BasePage';
import Session from '../services/session'
import Banner from '../partials/Banner';
import i from '../imports';
import c from '../components';
import navigation from '../navigation';

import BreadCrumbs from '../partials/BreadCrumbs';

const EMPTY_FILTER_VALUE = "empty_filter_value";


const flighttrainsToDisplay = 6;
const underlineStyle = {
    borderColor: "#FF5563"
}
const floatingLabelStyle = {
    color: "#FF5563"
}

const floatingLabelStyleInForm = {
    color: "#BDBDBD"
}

class flighttrains extends Component {

    constructor(props) {
        super(props);
        this.state = {
            flighttrainsToDisplay,
            accsToDisplay: flighttrainsToDisplay,
            openDialog: false
        }

    }

    readFlightTrains = () => {
        let filteredflighttrains = Session.model.flightTrains;
        let displayedflighttrains = filteredflighttrains;

        return {
            displayedflighttrains,
            filteredflighttrains,
            hasMore: filteredflighttrains.length < filteredflighttrains.length
        };
    }



    handleOpen = () => {
        this.setState({
            openDialog: true
        })
    };

    handleClose = () => {
        this.setState({
            openDialog: false
        })
    };

    render() {
        let flighttrainsData = this.readFlightTrains();
        let flighttrains = Session.model.flightTrains;

        // <Banner
        //     images={Session.getBannerPictures(Session.model.flightTrains.banner)}
        //     title={Session.model.flightTrains.slogan1}
        //     text={Session.model.flightTrains.slogan1}
        // />

        return (
            <BasePage data={Session.model.flightTrains}>
                <BreadCrumbs fullpath={window.location.pathname} name={""} />
                <i.Container>
                    <i.Row>
                        <i.Col align="left">
                            <div>{i.markdown(Session.model.flightTrains.text)}</div>
                        </i.Col>
                    </i.Row>
                    <i.Row style={{ paddingBottom: 30 }}>
                        <i.Col xs={12} align="center">
                            <button
                                className='button'
                                onClick={this.handleOpen}
                            >{Session.model.flightTrains.button}</button>
                            {/*<i.RaisedButton label="_REQUEST_"
                                    backgroundColor="#FF5563"
                                    labelColor="white"
                                    style={{backgroundColor: "#FF5563"}}/>*/}
                            <c.FormDialog
                                form_title={Session.model.flightTrains.title}
                                form_description={Session.model.flightTrains.form_description}
                                openDialog={this.state.openDialog}
                                onClose={this.handleClose}
                                requestType ='ticketRequest'
                            >
                            </c.FormDialog>
                        </i.Col>
                    </i.Row>
                </i.Container>
            </BasePage>
        );
    }
}

export default flighttrains;